import { NgModule } from '@angular/core';
import { CoreTableFixedVirtualScrollDirective } from '@dice/app/libraries/core-table-virtual-scrolling/virtual-scroll/virtual-scroll.directive';

const components = [CoreTableFixedVirtualScrollDirective];

@NgModule({
  declarations: components,
  exports: components,
})
export class CoreTableVirtualScrollModule {}
